import { is } from 'stdlib/is'

import { baseGlobals } from '@root/typescript/baseGlobals'

import Storage from '../Storage/Storage'

/**
 * A DevTools-ból felülírható eszköz-tulajdonságok.
 * - touch: érintőképernyős, kézi eszközt szimulálunk (isTouchSupported, isHandheld, html.touch / .handheld).
 */
export type TDevOverride = 'touch'

const storage = new Storage<TDevOverride>('sen-dev-tools.override')

// Az oldal élete alatt nem változik az érték: váltáskor a DevTools újratölti az oldalt,
// mert az eszköz-detektálást (pl. setDeviceClasses) az appok induláskor egyszer futtatják.
const cache = new Map<TDevOverride, boolean>()

function read (key: TDevOverride): boolean {
  try {
    return storage.get(key) === '1'
  }
  catch {
    return false
  }
}

/**
 * Be van-e kapcsolva a felülírás? Éles buildben mindig false.
 * @param key - A felülírás neve.
 */
function isOn (key: TDevOverride): boolean {
  if (!baseGlobals.isDev) {
    return false
  }

  let value = cache.get(key)

  if (is.undefined(value)) {
    value = read(key)

    cache.set(key, value)
  }

  return value
}

/**
 * Felülírás be- / kikapcsolása. A következő oldalbetöltéstől érvényes.
 * @param key       - A felülírás neve.
 * @param isEnabled - Bekapcsoljuk?
 */
function set (key: TDevOverride, isEnabled: boolean): void {
  if (!baseGlobals.isDev) {
    return
  }

  try {
    if (isEnabled) {
      storage.set(key, '1')
    }
    else {
      storage.remove(key)
    }
  }
  catch {
    // Letiltott storage (pl. privát ablak): nincs mit tenni.
  }
}

/** A gyorsítótár ürítése (teszteléshez). */
function reset (): void {
  cache.clear()
}

const devOverrides = {
  isOn,
  set,
  reset
} as const

export default devOverrides
